module.exports = __webpack_public_path__ + "static/03-49d5a3b12904c8247a899bc3eefb7ed0.jpg";